import { css } from "styled-components";
import LatoBold from "fonts/lato-v22-latin-700.woff"; /* Chrome 26+, Opera 23+, Firefox 39+ */
import LatoBoldTwo from "fonts/lato-v22-latin-700.woff2"; /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
import LatoRegular from "fonts/lato-v22-latin-regular.woff"; /* Chrome 26+, Opera 23+, Firefox 39+ */
import LatoRegularTwo from "fonts/lato-v22-latin-regular.woff2"; /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */

export const fontFace = css`
  @font-face {
    font-family: "Lato";
    font-style: normal;
    font-weight: 400;
    src:
      local(""),
      url(${LatoRegular}) format("woff"),
      url(${LatoRegularTwo}) format("woff2");
  }
  @font-face {
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    src:
      url(${LatoBold}) format("woff"),
      url(${LatoBoldTwo}) format("woff2");
  }
`;

const globalCSS = css`
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }

  * {
    box-sizing: border-box;
  }

  body {
    background-color: ${({ theme }) => theme.colors.bgDark};
    font-family: ${({ theme }) => theme.text.primaryFamily};
    font-size: ${({ theme }) => theme.text.size.base};
    line-height: ${({ theme }) => theme.lineHeight};
    margin: 0;
  }

  ${fontFace}

  /* Prevent elements jumping as scrollbar appears/disappears */
  #root {
    overflow-y: scroll;
    min-height: 100vh;
  }

  ol,
  ul {
    list-style: none;
  }

  blockquote,
  q {
    quotes: none;
  }

  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: "";
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  a {
    text-decoration: none;
  }

  // For salesforce chat widget overrides
  .embeddedServiceHelpButton .helpButton .uiButton {
    @font-face {
      font-family: "Salesforce Sans";
      src:
        url("https://c1.sfdcstatic.com/etc/clientlibs/sfdc-aem-master/clientlibs_base/fonts/SalesforceSans-Regular.woff")
          format("woff"),
        url("https://c1.sfdcstatic.com/etc/clientlibs/sfdc-aem-master/clientlibs_base/fonts/SalesforceSans-Regular.ttf")
          format("truetype");
    }

    background-color: ${({ theme }) => theme.colors.uiDark};
    font-family: "Salesforce Sans", sans-serif;
  }
  .embeddedServiceHelpButton .helpButton .uiButton:focus {
    outline: 1px solid ${({ theme }) => theme.colors.uiDark};
  }
`;

export default globalCSS;
